// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"profile-menu-mobile-m__wrapper__1Ao-_"};